const parametrizationSimilarProdutctHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Id',
        id: 'empresa-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'empresa-nome',
        show: true
      }
    ]
  },
  {
    group: 'Produto novo',
    columns: [
      {
        name: 'Id',
        id: 'produto-novo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'produto-novo-nome',
        show: true
      }
    ]
  },
  {
    group: 'Produto similar',
    columns: [
      {
        name: 'Id',
        id: 'produto-similar-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'produto-similar-nome',
        show: true
      }
    ]
  },
  {
    group: 'Percentual Da Demanda Absorvida',
    columns: [
      {
        name: '%',
        id: 'percentual-demanda',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Data',
    columns: [
      {
        name: 'Inicio',
        id: 'data-inicio',
        show: true
      },
      {
        name: 'Fim',
        id: 'data-fim',
        show: true
      }
    ]
  },
  {
    group: 'Configuração',
    columns: [
      {
        name: 'Nome',
        id: 'usuario',
        show: true
      },
      {
        name: 'Data',
        id: 'criado',
        show: true
      }
    ]
  }
]

export default parametrizationSimilarProdutctHeader
